import { BaseEntity } from '../../../base-entity';
import { UserSummaryType } from '../../../user/user-summary.type';
import { AttendanceType } from '../../../lecturers/attendance/attendance-type';

export interface ExamSessionsEnrollmentEntity extends BaseEntity {
  id: number;
  studentId: number;
  sessionId: number;
  eligibility: ExamStudentEligibility;
  enrollment: boolean;
  scheduleId: number;
  disableSelfEnrollment: boolean;
  selfEnrollmentDueDate: Date | null;
  attended: AttendanceType | null;
  grade: number | null;
  appealingGrade: number | null;
}

export interface EnrollmentWithUserDb
  extends ExamSessionsEnrollmentEntity,
    UserSummaryType {
  classId: number;
}

export enum ExamStudentEligibility {
  ELIGIBILITY = 'eligibility',
  NOT_ELIGIBILITY = 'not_eligibility',
  EXCLUDED = 'excluded',
}
